import * as colors from "../constants/colors";
import * as breakpoints from "../breakpoints";
import * as languages from "../constants/languages";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../constants/strings";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { rootUrl } from "../config.js";
import { format } from "date-fns";
import * as es from "date-fns/locale/es";
import * as en from "date-fns/locale/en";

const dateFormat = "MMMM D h:mmA";

const styles = StyleSheet.create({
	button: {
		color: colors.gold2,
		borderRadius: 20,
		width: 154,
		paddingTop: 7,
		paddingBottom: 7,
		lineHeight: 1.4,
		fontSize: 15,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontWeight: "bold",
	},
	buttonsContainer: {
		marginTop: 32,
		[breakpoints.mobileOnly]: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	cancelButton: {
		[breakpoints.tabletAndUp]: {
			marginLeft: 16,
		},
		[breakpoints.mobileOnly]: {
			marginTop: 12,
		},
	},
	closeIconButton: {
		border: "none",
		backgroundColor: colors.white,
		marginLeft: 16,
	},
	container: {
		position: "absolute",
		maxWidth: 580,
		paddingTop: 20,
		paddingBottom: 30,
		backgroundColor: colors.white,
		zIndex: 2,
		[breakpoints.mobileOnly]: {
			width: "100vw",
		},

		"@media (max-height: 750px)": {
			marginBottom: 0,
			height: "100vh",
		},
	},
	fullScreenCover: {
		position: "fixed",
		height: "100vh",
		width: "100vw",
		backgroundColor: colors.transparentTeal,
		top: 0,
		left: 0,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 1,

		"@media (max-height: 750px)": {
			alignItems: "flex-start",
			overflow: "auto",
		},
	},
	header: {
		fontSize: 20,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontWeight: "bold",
	},
	label: {
		fontSize: 15,
		lineHeight: 1.33,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		marginBottom: 16,
	},
	triangle: {
		position: "absolute",
		top: 0,
		left: "25%",
		width: 0,
		height: 0,
		border: "20px solid transparent",
		borderBottomColor: colors.white,
		borderTop: 0,
		marginLeft: "-20px",
		marginTop: "-20px",
		backgroundColor: "transparent",
	},
	padding: {
		paddingTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
	},
	headerRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		paddingLeft: 20,
		paddingRight: 20,
		paddingBottom: 8,
		borderBottom: `2px dashed ${colors.gray5}`,
	},
});

export default class LiveSessionModal extends PureComponent {
	static propTypes = {
		showing: PropTypes.bool,
		language: PropTypes.string.isRequired,
		dismiss: PropTypes.func.isRequired,
		title: PropTypes.string,
		description: PropTypes.string,
		url: PropTypes.string,
		startTime: PropTypes.Date,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;
	}

	_dismiss = () => {
		this.props.dismiss();
	};

	_dontPropagate = e => {
		e.stopPropagation();
	};

	render() {
		if (!this.props.showing) {
			return null;
		}
		const locale = { locale: this.props.language === languages.es ? es : en };

		return (
			<div onClick={this._dismiss} className={css(styles.fullScreenCover)}>
				<div onClick={this._dontPropagate} className={css(styles.container)}>
					<div className={css(styles.headerRow)}>
						<div className={css(styles.header)}>{this.props.title}</div>
						<button className={css(styles.closeIconButton)} onClick={this._dismiss}>
							<img
								alt="x"
								src={`${rootUrl}/images/x.png`}
								srcSet={`${rootUrl}/images/x@2x.png 2x, ${rootUrl}/images/x@3x.png 3x`}
								width="20"
								height="20"
							/>
						</button>
					</div>
					<div className={css(styles.padding)}>
						{this.props.startTime ? (
							<div className={css(styles.label)}>
								{format(this.props.startTime, dateFormat, locale)}
							</div>
						) : null}
						<div className={css(styles.label)}>{this.props.description}</div>
						<a className={css(styles.button)} href={this.props.url}>
							{this.strings.learnMore}
						</a>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LiveSessionModal.js